import React, { useEffect, useState } from "react";
import { Drawer } from "antd";
import { IoReorderTwoOutline } from "react-icons/io5";
import {
  formatMobileNumber,
  getNameInitials,
} from "../../Utils/HelperFunctions";
import { RxCross2 } from "react-icons/rx";
import Helpline from "../../Components/Helpline";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../Components/PrimaryButton";
import CartMenuIcon from "../../assets/images/cart_menu.svg";
import HomeIcon from "../../assets/images/home_filled.png";
import WishlistIcon from "../../assets/images/wishlist_menu.svg";
import OrderIcon from "../../assets/images/ordersicon_black.svg";
import FaqIcon from "../../assets/images/faq_menu.svg";
import TermIcon from "../../assets/images/tc_menu.svg";
import PrivacyIcon from "../../assets/images/privacy_policy_menu.svg";
import ReturnIcon from "../../assets/images/returns.svg";
import LogoutIcon from "../../assets/Svg/logout.svg";
import { useAuth } from "../../Hooks/AuthContext";
// import { Avatar } from "@nextui-org/react";

function MenuItems(props) {
  return (
    <div
      className={`flex flex-row w-full h-12 items-center my-2 px-4 cursor-pointer ${
        props.active === props.item.name ? "bg-[#DDE3FC] rounded-full" : null
      } `}
      onClick={() => props.handleClick(props.item)}
    >
      <img
        src={
          props.active === props.item.name ? props.item.icon : props.item.icon
        }
        alt={props.item.name}
        className="h-6 w-6 mr-3 text-textColor"
      />
      <p
        className={`text-sm ${
          props.item.name === "Log Out" ? "text-textColor" : "text-textColor"
        } font-light ${props.active === props.item.name ? "font-normal " : ""}`}
      >
        {props.item.name}
      </p>
    </div>
  );
}

const CustomDrawer = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("Home");
  const user_name = localStorage.getItem("name");
  const handleClick = (item) => {
    setActive(item.name);
    if (item?.name === "Log Out") {
      logout();
    } else {
      navigate(item.path);
    }
  };

  useEffect(() => {
    if (user?.number) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  }, [user]);
  const menuItems = [
    {
      name: "Home",
      icon: HomeIcon,
      path: "/",
      auth: false,
    },
    {
      name: "Cart",
      icon: CartMenuIcon,
      path: "/cart-products",
      auth: false,
    },
    {
      name: "Wishlist",
      icon: WishlistIcon,
      path: "/wishlist",
      auth: true,
    },
    {
      name: "Orders",
      icon: OrderIcon,
      path: "/customer/all-orders",
      auth: true,
    },
    {
      name: "FAQ's",
      icon: FaqIcon,
      path: "/faq",
      auth: false,
    },
    {
      name: "Terms and Conditions",
      icon: TermIcon,
      path: "/terms-and-conditions",
      auth: false,
    },
    {
      name: "Privacy Policy",
      icon: PrivacyIcon,
      path: "/privacy-policy",
      auth: false,
    },
    {
      name: "Returns and Cancellation Policy ",
      icon: ReturnIcon,
      path: "/returns-and-cancellation-policy",
      auth: false,
    },
    {
      name: "Log Out",
      icon: LogoutIcon,
      auth: true,
      path: "/auth/login",
    },
  ];
  return (
    <>
      <IoReorderTwoOutline
        size={25}
        onClick={() => setOpen(true)}
        className="cursor-pointer"
      />
      <div className="">
        <Drawer
          placement="left"
          closable={false}
          onClose={() => setOpen(false)}
          open={open}
          key="left"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          <div className="flex space-x-2">
            {loggedIn === true ? (
              [{ name: user_name, number: user?.number }].map((data, index) => (
                <div key={index} className=" w-full h-auto my-4 ">
                  <div className="flex flex-row align-middle items-center">
                    <div className="mr-1">
                      {/* <Avatar src="https://i.pravatar.cc/150?u=a042581f4e29026024d" /> */}
                      <div className="w-12 text-white h-12 mr-3  bg-green rounded-full font-normal flex justify-center items-center">
                        {getNameInitials({ name: data.name || "" })}
                      </div>
                    </div>
                    <div className="flex flex-col justify-between w-full items-center">
                      {data?.name?.trim() ? (
                        <div className="flex flex-row justify-between w-full">
                          <p className="text-[#21314a] text-base font-normal mr-2">
                            {data?.name}
                          </p>
                        </div>
                      ) : null}
                      <div className="flex flex-row justify-between w-full">
                        <p
                          className={`${
                            data?.name?.trim()
                              ? "text-[#425462]"
                              : "text-lg font-normal"
                          } `}
                        >
                          +91 {formatMobileNumber(data?.number)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="w-full my-2">
                <PrimaryButton
                  text="Log in / Sign up"
                  onClick={() =>
                    navigate("/auth/login", {
                      state: { from: window.location.pathname },
                    })
                  }
                />
              </div>
            )}
            <div className="flex  justify-end items-center">
              <RxCross2 size={20} onClick={() => setOpen(false)} />
            </div>
          </div>
          <div className="flex flex-grow flex-col">
            {menuItems.map((item, index) => (
              <div key={index}>
                {item.auth ? (
                  <>
                    {loggedIn && (
                      <MenuItems
                        key={index}
                        active={active}
                        handleClick={handleClick}
                        item={item}
                      />
                    )}
                  </>
                ) : (
                  <MenuItems
                    key={index}
                    active={active}
                    handleClick={handleClick}
                    item={item}
                  />
                )}

                {(index === 3 || index === 7) && <hr></hr>}
              </div>
            ))}
          </div>
          <div className="mt-auto">
            <Helpline />
          </div>
        </Drawer>
      </div>
    </>
  );
};
export default CustomDrawer;
